import { render, staticRenderFns } from "./TotalExpense.vue?vue&type=template&id=3656d89c"
import script from "./TotalExpense.vue?vue&type=script&lang=js"
export * from "./TotalExpense.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports